import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: '4px !important',
    boxShadow:
      '0 1px 10px 0 rgba(9, 32, 86, 0.12), 0 4px 5px 0 rgba(9, 32, 86, 0.14), 0 2px 4px -1px rgba(9, 32, 86, 0.20) !important',
    padding: '10px !important',
    backgroundColor: '#FFFFFF !important',
    color: 'var(--primary-dark) !important',
    fontSize: '0.625rem !important',
    fontFamily: 'Poppins, sans-serif !important',
    fontWeight: '500 !important',
    lineHeight: '140% !important',
    letterSpacing: '0.16px !important',
    transform: 'translateY(0.5rem) !important',
  },
  '& .MuiTooltip-tooltip.MuiTooltip-tooltipPlacementTop.css-ja5taz-MuiTooltip-tooltip':
    {
      margin: 0,
    },
}));
